import type React from 'react'
import { Link } from 'react-router-dom'
import { OrgSwitcher } from '@/components/org-switcher'
import { OmniSearch } from './omni-search'
import { NotificationBell } from './notification-bell'
import { UserMenu } from './user-menu'

export interface HeaderBarProps {
  readonly orgSlug: string
}

export function HeaderBar({ orgSlug }: HeaderBarProps): React.ReactElement {
  return (
    <header className="flex items-center gap-4 border-b border-border bg-surface-elevated px-6 py-2.5">
      <div className="flex items-center gap-3">
        <Link
          to={orgSlug ? `/${orgSlug}/plans` : '/'}
          aria-label="KnowNow home"
          data-testid="logo-link"
          className="rounded-sm font-serif text-lg tracking-tight text-foreground no-underline hover:opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        >
          Know<span className="text-primary">Now</span>
          <span className="text-primary">.</span>
        </Link>
        <span className="hidden h-6 w-px bg-border sm:block" />
        <OrgSwitcher currentSlug={orgSlug} />
      </div>

      <div className="hidden flex-1 justify-center md:flex">
        <OmniSearch />
      </div>

      <div className="ml-auto flex items-center gap-2">
        <NotificationBell />
        <UserMenu />
      </div>
    </header>
  )
}
